<template>
  <div class="login">
    <notifications position="bottom center" />
    <img :src="require('../../assets/logo.png')" class="logo" />
    <div class="left-black browser"></div>
    <div class="right">
      <div class="box-login">
        <center>
          <img :src="require('../../assets/logo.png')" class="logo-mobile mobile" />
        </center>
        <h1 style="display: flex; align-items: center" class="login-title">
          ACIUM POS PLAY
          <img
            :src="require('../../assets/logo.png')"
            width="32"
            height="32"
            style="transform: rotate(90deg)"
          />
        </h1>
        <div class="form-input">
          <i class="far fa-user"></i>
          <input placeholder="usuário" v-model="username" />
        </div>
        <div class="form-input">
          <i class="fas fa-unlock-alt"></i>
          <input placeholder="senha" type="password" v-model="password" />
        </div>
        <div class="btn-login" @click="login()">ENTRAR</div>
        <p>
          Não lembra sua senha?
          <router-link to="forgot_password">clique aqui</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    username: null,
    password: null,
    remeber: false,
  }),
  created() {
    this.validate();
  },
  methods: {
    validate() {
      if (this.$user != null) {
        this.$router.push("/dashboard").catch(() => {});
      }
    },
    error(message) {
      this.$notify({
        title: message,
        type: "error",
      });
    },
    success(name) {
      this.$notify({
        title: `Sejá bem-vindo ${name}`,
        type: "success",
      });
    },
    async login() {
      let data = {
        username: this.username,
        //  email: this.username,
        password: this.password,
        remeber: this.remeber,
      };
      this.$http
        .post(`/login`, data)
        .then((response) => response.data)
        .then(async (json) => {
          if (json.token) {
            await localStorage.setItem("words", JSON.stringify(json.words));

            await localStorage.setItem("api_token", json.token);
            await localStorage.setItem("user", JSON.stringify(json));

            if (json.user.code_language) {
              translateTo(json.user.code_language);
            }
            this.success(json.user.name);

            location.reload();
            this.$router.push("/dashboard");
          } else {
            this.error("Email ou senha inválido");
          }
        })
        .catch((e) => {
          this.$notify({
            title: e.response.data.message,
            type: "error",
          });
        });
    },
  },
};
</script>
